

export enum KalturaUploadTokenStatus {
    closed=3,
	deleted=5,
	fullUpload=2,
	partialUpload=1,
	pending=0,
	timedOut=4
}